import type { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { figureLegacyZeroV0Schema } from './zero';

export type LegacyFigureZero = z.infer<typeof figureLegacyZeroV0Schema>;
export type LegacyFigure = LegacyFigureZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Unlike button/video there is no envelope union — figure only ships the
 * zero-block placement, so the zero schema is the variant schema. Single 'web'
 * variant today; the mini-landing shape becomes a second variant when the widget
 * is unified across apps.
 */
export const LegacyFigureEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: figureLegacyZeroV0Schema }]);
